import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import RoundIconComponent from "../../RoundIconComponent";

const ReservationCheckoutCard = (props) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box sx={{ width: 48, height: 48, borderRadius: 1.5, flexShrink: 0 }}>
        {" "}
        <RoundIconComponent children={props?.children} />
      </Box>

      <Box sx={{ minWidth: 100, flexGrow: 1 }}>
        <Typography
          color="inherit"
          variant="subtitle2"
          underline="hover"
          noWrap
        >
          {props.type}
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          {`${props?.spotLimit} spots available`}
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          {props?.chargePerDay}
        </Typography>
      </Box>

      <Box>
        <Typography
          variant="body2"
          align="center"
          sx={{
            color: "text.secondary",
            alignSelf: "center",
            backgroundColor: "#DADADA63",
            height: "24px",
            width: "24px",
            borderRadius: "5px",
            justifyContent: "center",
          }}
        >
          {props?.selectedCount}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", alignSelf: "center" }}
        >
          {`$${props?.totalCost.toFixed(2)}`}
        </Typography>
      </Box>
    </Stack>
  );
};

export default ReservationCheckoutCard;
